module.exports = {
	"articleTitle1": "Nate Wood: Valentine's Day meals on a budget",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Gandy Dancer",
	"totalMisc": 0,
	"articleLink2": "https://www.michigandaily.com/section/news/amtrak-story",
	"articleSnippet1": "Feb 12, 2014 ... Using the Valentine's Day menus at the Melting Pot, Chop House and Gandy \nDancer as inspiration, I've crafted three do-it-yourself dinner ...",
	"articleSnippet2": "Sep 7, 2016 ... The third possible station design, also located on Depot Street, would replace the \nGandy Dancer restaurant, repurposing the building as a train ...",
	"articleLink1": "#",
	"articleTitle2": "City leaders divided over four new possible Amtrak locations ",
	"address": "401 Depot St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.287246,
		"lng": -83.741695
	},
	"foodRecommendations": [
		{
			"text": "It's pricey, but I enjoy the steak every time I go.",
			"person": "Andrew Fridenberg"
		}
	],
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/gandydancer.json
// module id = 882
// module chunks = 0